// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260315/js/" + chunkId + "." + {"44":"1f9ef2b7","225":"a92b6aba","481":"f4916df5","486":"0f0e2b9d","770":"82e2ee34"}[chunkId] + ".0.11999518378183005.chunk.js";
};